/**
 * Created by vlad.p on 9/22/2017.
 */

export enum OrderOptions {
    None = 0,
    IsOcean = 1,
    IsOneTime = 2,
    IsQuickQuote = 4,
    IsPulic = 8,
    IsVehicle = 16,
    IsUsService = 32,
    IsBBFeeEdited = 64,
    IsCommercialCarrier = 128,
    IsDrivingAcross = 256,
    ContinuousBondOnFile = 512
}



// WEBPACK FOOTER //
// ./app/objects/orders/orderOptions.ts